import { VerticalCustom as WellIcon } from '@repo/go-icons';
import { Select } from '@repo/go-ui';
import { observer } from 'mobx-react-lite';
import { useSearchParams } from 'react-router-dom';

import { useService } from 'src/packages/di';

import type { BasicParametersStore } from '../BasicParameters.store';

import styles from './selects.module.scss';

interface Props {
  store: BasicParametersStore;
  itemView: {
    statusColor: Partial<Record<string, string>>;
    statusField: string;
  };
}

export const WellsSelect = observer(function WellsSelect({ store, itemView }: Props) {
  const { theme } = useService('theme');
  const { isWellsLoading, currentWell, wellsOptions } = store;
  const [_, setSearchParams] = useSearchParams();

  function handleSelect(value: string) {
    store.setCurrentWell(value);
    setSearchParams((searchParams) => {
      searchParams.set('wellId', value);
      searchParams.delete('wellboreId');
      return searchParams;
    });
  }

  return (
    <Select
      loading={isWellsLoading}
      disabled={isWellsLoading}
      className={styles.wellSelect}
      showSearch
      filterOption={(inputValue, option) => {
        if (option && option.label) {
          const lowerInput = inputValue.toLowerCase();

          return String(option.label).toLowerCase().includes(lowerInput);
        }
        return false;
      }}
      value={currentWell ? currentWell.name : null}
      onSelect={handleSelect}
      options={wellsOptions}
      optionRender={(option) => {
        const color =
          option.data.status === 'COMPLETED' && theme === 'light'
            ? '#788CB9'
            : itemView.statusColor[option.data.status];
        return (
          <div className={styles.selectOption}>
            <WellIcon className={styles.drillingIcon} style={{ color: color ?? '#ffffff80' }} />
            {option.label}
          </div>
        );
      }}
    />
  );
});
